import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';

import { DEFAULT_SITE_DESCRIPTION, DEFAULT_SITE_KEYWORDS, OgType, SITE_LOGO, SITE_NAME, SITE_URL } from '@app/types/seo.types';
import { environment } from '@environments/environment';
import { ScrollService } from '@app/common/services/scroll.service';
import { SeoService } from '@app/common/services/seo.service';
import { RouterLink } from '@angular/router';

declare let __ucCmp: any;

@Component({
  selector: 'app-privacy-policy',
  imports: [RouterLink],
  templateUrl: './privacy-policy-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './privacy-policy-page.component.scss'
})
export class PrivacyPolicyPageComponent implements OnInit {
  private scrollService = inject(ScrollService);
  private seoService = inject(SeoService);

  ngOnInit(): void {
    this.seoService.setSeoData({
      title: 'Polityka prywatności',
      description: DEFAULT_SITE_DESCRIPTION,
      keywords: DEFAULT_SITE_KEYWORDS,
      ogImage: {
        url: SITE_LOGO,
        alt: `${SITE_NAME} Logo`
      },
      ogUrl: SITE_URL,
      ogType: OgType.Article
    });
    this.scrollService.scrollToTop();
  }

  openCookieSettings(e: MouseEvent): void {
    e.preventDefault();
    if (!environment.production) {
      return;
    }
    __ucCmp.showSecondLayer();
  }
}
